import { AxiosClient } from "./AxiosClient";

export const getCases = () => {
  try {
    return AxiosClient.get("cases/getCases");
  } catch (e) {
    console.log(e);
  }
};

export const sendCompanySearch = (company) => {
  try {
    return AxiosClient.post("cases/search", { company_name: company });
  } catch (e) {
    console.log(e);
  }
};

export const sendCompanySearchBackUp = (company) => {
  try {
    return AxiosClient.post("cases/backup_search", { company_name: company });
  } catch (e) {
    console.log(e);
  }
};

export const validateURL = (url) => {
  try {
    return AxiosClient.post("cases/validateURL", { url });
  } catch (e) {
    console.log(e);
  }
};

export const saveCase = (caseName, domain) => {
  try {
    return AxiosClient.post("cases/saveCase", { caseName, domain });
  } catch (e) {
    console.log(e);
  }
};

export const getClipboardTerms = () => {
  try {
    return AxiosClient.get("saved/getRecentClipboardTerms");
  } catch (e) {
    console.log(e);
  }
};

export const addToClipboard = (term) => {
  try {
    return AxiosClient.post("saved/addClipboardTerm", { term });
  } catch (e) {
    console.log(e);
  }
};

export const deleteFromClipboard = (term) => {
  try {
    return AxiosClient.post("saved/deleteClipboardTerm", { term });
  } catch (e) {
    console.log(e);
  }
};

export const getDocIdData = (document_id) => {
  try {
    return AxiosClient.get("cases/getDocIdData?document_id=" + document_id);
  } catch (e) {
    console.log(e);
  }
};

export const getDocsbyIds = (doc_ids) => {
  try {
    return AxiosClient.get("chat/getDocsbyIds?doc_ids=" + doc_ids);
  } catch (e) {
    console.log(e);
  }
};

export const getDocsbyUrls = (urls) => {
  try {
    return AxiosClient.get("chat/getDocsbyUrls?urls=" + urls);
  } catch (e) {
    console.log(e);
  }
};
